interface FeatureItem {
  title?: string;
  content?: string;
  image?: { imageUrl?: string };
}

interface Props {
  data: FeatureItem;
}

const CourseItemBox = ({ data }: Props) => {
  return (
     <div className="w-full justify-center flex mb-[24px] px-[10px]">
    <div className="overflow-hidden text-ellipsis pr-4 max-w-[75%]">
      <img
        className="mb-[24px]"
        src={data?.image?.imageUrl}
        alt={data?.title || ""}
      />
      <div className="flex justify-between mb-[1px]">
        <div className="text-[24px] font-500 mobile:text-[20px]">
          {data?.title}
        </div>
      </div>
      <div className="text-[16px] font-400 mobile:text-[14px] mb-[0px] mobile:mb-[0px]">
        {data?.content}
      </div>
    </div>
    </div>
  );
};

export default CourseItemBox;


// const CourseItemBox = ({ data }: any) => {
//   return (
//     <div className="inline-flex flex-col cursor-pointer  w-full max-w-[400px]">
//       <img
//         className="mb-[24px]"
//         src={data?.image?.imageUrl}
//       />
//       <div className="flex justify-between mb-[1px]">
//         <div className="text-[24px] font-500 mobile:text-[20px]">
//           {data?.title}
//         </div>
//       </div>
//       <div className="text-[16px] font-400 mobile:text-[14px] mb-[5px] mobile:mb-[5px]">
//         {data?.content}
//       </div>
//     </div>
//   );
// };
//
// export default CourseItemBox;
